import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'
import client from './client'
import device from './device'
import api from './api'
import software from './software'
import setting from './setting'
import ums from './ums'
import data from './data'
import report from './report'
import dataFolder from './dataFolder'
import mental from "./mental"
import questionnaire from "./questionnaire"

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {path: '/ums', component: () => import('@/views/ums/admin/resertPassword'), hidden: true},
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    level: 0,
    meta: {title: '华见智能', icon: 'home'},
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/layout'),
      meta: {title: '首页', icon: 'home'}
    }]
  },

]

export const asyncRouterMap = [
  client,
  device,
  api,
  software,
  setting,
  ums,
  data,
  dataFolder,
  report,
  mental,
  questionnaire,
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  //	base: '/dist',
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js